<app-card
  #cardComponent
  [title]="'PEOPLE_FORM.FORM.CONTACTS.TITLE' | translate"
  [index]="index()"
  (deleteCard)="remove.emit()"
  [totalItems]="totalItems()"
>
  <app-form-area
    hiddenButtons
  >
    <app-select
      [label]="'PEOPLE_FORM.FORM.CONTACTS.TYPE_SELECT.TITLE' | translate"
      [placeholder]="'PEOPLE_FORM.FORM.CONTACTS.TYPE_SELECT.PLACEHOLDER' | translate"
      [control]="control().get('type')"
      [items]="contactsTypeOptions"
    />
    <app-input
      type="text"
      [label]="'PEOPLE_FORM.FORM.CONTACTS.NAME' | translate"
      [placeholder]="'PEOPLE_FORM.FORM.CONTACTS.NAME_PLACEHOLDER' | translate"
      [control]="control().get('name')"
    />
    <app-input
      type="text"
      [label]="'PEOPLE_FORM.FORM.CONTACTS.NICKNAME' | translate"
      [placeholder]="'PEOPLE_FORM.FORM.CONTACTS.NICKNAME_PLACEHOLDER' | translate"
      [control]="control().get('surName')"
    />
    <app-input
      type="text"
      [label]="'PEOPLE_FORM.FORM.CONTACTS.PHONE' | translate"
      [placeholder]="'PEOPLE_FORM.FORM.CONTACTS.PHONE_PLACEHOLDER' | translate"
      [control]="control().get('telephone')"
      mask="phone"
    />
    <div class="slide-toggle-container">
      <mat-slide-toggle
        labelPosition="before"
        [checked]="control().get('isMain')?.value"
        (change)="control().get('isMain')?.setValue($event.checked)"
        color="primary"
      >
        {{ 'PEOPLE_FORM.FORM.CONTACTS.MAIN_TELEPHONE' | translate }}
      </mat-slide-toggle>
    </div>
  </app-form-area>
</app-card>
